/** @jsxImportSource @emotion/react */
import CardIcon from '../../cardPicker/CardIcon';
import { Row } from '../../Utils';
import t from '@rcm/i18n-client';

interface Props {
  cardType: string;
  cardNumber: string;
}

/**
 * Simple wrapper that displays the card type icon and last 4 digits if it exists
 *
 * @param cardType the brand of card e.g. 'visa', 'amex' etc
 * @param cardNumber the last four digits of the credit card number
 */
const CardInfoDisplay = ({ cardType, cardNumber }: Props) => (
  <Row justifyContent='flex-start' alignItems='center' sx={{ gap: '10px' }}>
    <CardIcon cardType={cardType} />
    {cardNumber ? (
      <p
        id='card-number-mocha'
        css={{
          fontSize: '18px',
          lineHeight: '18px',
          fontweight: 'bold',
          paddingTop: '4px',
        }}
      >
        {t('Card ending in:')} {cardNumber?.slice(12)}
      </p>
    ) : null}
  </Row>
);
export default CardInfoDisplay;
